import React from 'react';
import { createPortal } from 'react-dom';
import bem from 'utils/bem';
import MenuLink from '../MenuLink';
import { IconButton } from 'components/Button';
import Model from '../../../../model';

import './index.sass'
import SocialIcons from 'components/SocialIcon/SocialIcons';

const { block, el } = bem('mobile-menu-body');

const MobileMenuBody = ({ isOpen, anchor, items, mods, rootRef = null }) => {

    const { openOrderForm } = Model.modal;

    const menuBody =
        <div ref={ rootRef } className={ block({ 'open': isOpen }, mods) }>
            <div className={ el('content') }>
                <div className={el('menu')}>
                    <ul className={ el('items') }>
                        { items.map(item => <MenuLink key={item.id} className={ el('item') } { ...item } />) }
                    </ul>
                    <div className={el('socials')}>
                        <SocialIcons />
                    </div>
                </div>
                <div className={el('button')}>
                    <IconButton mod='gold' name={'arrow-right'} onClick={openOrderForm}>Записаться</IconButton>
                </div>
            </div>
        </div>;

    return (
        createPortal(
            menuBody, anchor
        )
    )
};

export default MobileMenuBody
